module.exports = vendor1_10389c70;